import { render, staticRenderFns } from "./protocol-sdk.vue?vue&type=template&id=6940b3f2&scoped=true&"
import script from "./protocol-sdk.vue?vue&type=script&lang=js&"
export * from "./protocol-sdk.vue?vue&type=script&lang=js&"
import style0 from "./protocol-sdk.vue?vue&type=style&index=0&id=6940b3f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6940b3f2",
  null
  
)

export default component.exports